import { render, staticRenderFns } from "./TrackTravel.vue?vue&type=template&id=53896a50&scoped=true"
import script from "./TrackTravel.vue?vue&type=script&lang=js"
export * from "./TrackTravel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53896a50",
  null
  
)

export default component.exports